// Router
import { replace } from "react-router-redux";
import { ADMIN, BASE_URL, CANDIDATE } from "../../config/constants";
// API
import { get, tokenPost } from "../../services/api";
// Ducks
import { fetchProfile, setTokens, fetchClaims } from "../../services/auth.ducks";
import { hideSpinner, showSpinner } from "../../services/spinner.ducks";
import {
  setErrorNotification,
  setNotification
} from "../../components/SmartNotification/SmartNotification.ducks";

export const login = (username, password) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const response = await dispatch(
      tokenPost({
        grant_type: `password`,
        username,
        password
      })
    );

    const role = response.headers.role && response.headers.role.toLowerCase();

    dispatch(setTokens(response.data.access_token, response.data.refresh_token, role, username));

    if (role === CANDIDATE) {
      await dispatch(fetchProfile());
    } else if (role === ADMIN) {
      await dispatch(fetchClaims());
    }
    dispatch(hideSpinner());

    return role === ADMIN
      ? dispatch(replace(`${BASE_URL}/dashboard/users`))
      : dispatch(replace(`${BASE_URL}/dashboard`));
  } catch (err) {
    dispatch(hideSpinner());
    if (err.response && err.response.status === 400) {
      dispatch(
        setErrorNotification({
          messageTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.wrongCredentials`,
          titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.error`
        })
      );
    } else {
      dispatch(
        setErrorNotification({
          messageTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.serverError`,
          titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.error`
        })
      );
    }
  }
};

export const recoverPassword = (username) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    await dispatch(get(`/user/reset?username=${username}`));
    dispatch(
      setNotification({
        type: `info`,
        titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.label.passwordResetSuccessTitle`,
        messageTranslationKey: `modules.localization.register.anonymous.smartNotifications.label.passwordResetSuccessMessage`
      })
    );
    dispatch(hideSpinner());
  } catch (err) {
    let message;

    if (err.response && err.response.data && err.response.data.message) {
      switch (err.response.data.message) {
        case `users.reset.get.error.candidate.notFound`:
          message = `modules.localization.register.authenticated.error.candidate.notFound`;
          break;
        case `users.reset.get.error.client.notFound`:
          message = `modules.localization.register.authenticated.error.client.notFound`;
          break;

        default:
          message = `modules.localization.register.anonymous.smartNotifications.error.generic`;
          break;
      }
    }

    dispatch(
      setErrorNotification({
        messageTranslationKey: message,
        titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.error`
      })
    );
    dispatch(hideSpinner());
  }
};
